<ui-modal
  [title]="'FORM_TIMEPICKER_MODAL_TITLE' | localization"
  [footer]="footerRef"
  (afterClose)="onAfterClose()"
  width="400px"
>
  <div class="time-picker-body">
    <div class="time-picker-columns">
      <!-- Hours Column -->
      <div class="time-column">
        <div class="mb-5"></div>
        <div
          #hourItemsCont
          class="time-scroll-container"
          [style.height.px]="containerHeight"
        >
          <div class="scroll-padding-top"></div>
          <div
            *ngFor="let item of hourItems; let i = index"
            #hourRefs
            class="time-item"
            [class.selected]="item.value === hourValue"
            [style.height.px]="itemHeight"
          >
            {{ item.label }}
          </div>
          <div class="scroll-padding-bottom"></div>
        </div>
      </div>

      <div class="time-separator">:</div>

      <!-- Minutes Column -->
      <div class="time-column">
        <div class="mb-5"></div>
        <div
          #minuteItemsCont
          class="time-scroll-container"
          [style.height.px]="containerHeight"
        >
          <div class="scroll-padding-top"></div>
          <div
            *ngFor="let item of minuteItems; let i = index"
            #minuteRefs
            class="time-item"
            [class.selected]="item.value === minuteValue"
            [style.height.px]="itemHeight"
          >
            {{ item.label }}
          </div>
          <div class="scroll-padding-bottom"></div>
        </div>
      </div>
    </div>

    <div class="time-picker-selector-line"></div>
  </div>
</ui-modal>
<ng-template #footerRef>
  <ui-button type="primary" [block]="true" (click)="submit()">
    <span>{{ 'FORM_TIMEPICKER_MODAL_BUTTON' | localization }}</span>
  </ui-button>
</ng-template>
